import React from 'react';
import { motion } from 'framer-motion';
export function OpeningLead() {
  return <section className="py-10 lg:py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-213">
      <div className="max-w-3xl mx-auto" data-id="element-214">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="prose prose-lg prose-headings:font-serif prose-p:text-charcoal/80 mx-auto text-center" data-id="element-215">
          <p className="text-lg sm:text-xl lg:text-2xl font-serif italic text-charcoal leading-relaxed mb-5 lg:mb-8" data-id="element-216">
            Hay una diferencia enorme entre{' '}
            <span className="text-china-red font-semibold" data-id="element-217">
              "viajar a China"
            </span>{' '}
            y <span className="text-china-red font-semibold" data-id="element-218">vivir China</span>.
          </p>

          <div className="w-16 h-1 bg-gold/30 mx-auto mb-6 lg:mb-10 rounded-full" data-id="element-219"></div>

          <p className="mb-4 lg:mb-6 text-sm lg:text-base" data-id="element-220">
            La primera opción es esta: llegas, estás cansado, intentas pagar
            algo simple… y de repente todo va demasiado rápido.
          </p>

          <p className="mb-4 lg:mb-6 text-sm lg:text-base" data-id="element-221">
            Tu móvil no ayuda, el mapa no encaja, el taxi te mira esperando una
            dirección clara, y tú piensas:{' '}
            <span className="italic font-medium text-charcoal" data-id="element-222">
              "Vale… ¿por dónde empiezo?"
            </span>
          </p>

          <p className="mb-5 lg:mb-8 text-sm lg:text-base" data-id="element-223">
            La segunda opción es mucho más aburrida (y por eso funciona):
          </p>

          <div className="bg-cream/50 p-5 lg:p-8 rounded-xl border border-gold/20 shadow-sm mb-6 lg:mb-10" data-id="element-224">
            <p className="font-medium text-base lg:text-lg text-charcoal m-0" data-id="element-225">
              Aterrizas con tu{' '}
              <span className="text-china-red font-bold" data-id="element-226">Kit Anti‑Bloqueo</span>{' '}
              montado, haces 3 cosas en el orden correcto, y el viaje empieza a
              fluir desde el día 1.
            </p>
          </div>

          <p className="font-serif text-lg lg:text-xl font-medium text-charcoal" data-id="element-227">
            Esta guía es para eso.
          </p>
        </motion.div>
      </div>
    </section>;
}